/**
 * 应用卡片分享
 */
import React, { useCallback, useMemo, useState } from "react";
import { MessageSendType } from "@/types/chat/enum";
import lodashGet from "lodash/get";
import styles from "./index.module.less";
import ChatState from "@/types/chat/State";
import { getTextMessageRemark } from "@/components/chat/utils/commonMessageModal";
import { connect } from "dva";
import WorkCardDetail from "./WorkCardDetail";
import ReferenceHeader from "../ReferenceHeader";
function mapStateToProps({ chat }: { chat: ChatState }) {
  const { currentEmployee, selectedSession, connectState } = chat;
  return {
    userInfo: currentEmployee,
    currentEmployee,
    selectedSession,
    connectState
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

function WrokSummaryCard(props: any) {
  const { currentEmployee, selectedSession, message, sendType } = props;

  const dataInfo = useMemo(() => {
    return lodashGet(message, "data.0", {
      schedules: [],
      pages: []
    });
  }, [message]);

  // 扩展数据
  const extData = useMemo(() => {
    if (!message?.ext) {
      return {};
    }
    try {
      return typeof message?.ext === "string" ? JSON.parse(message?.ext) : message?.ext;
    } catch (e) {
      return {};
    }
  }, [message?.ext]);

  const aiTitle = useMemo(() => {
    return extData?.ai_type || "";
  }, [extData.ai_type]);

  const showSummeryDetail = useMemo(() => {
    return dataInfo?.schedules?.length || dataInfo?.pages?.length;
  }, [dataInfo?.pages?.length, dataInfo?.schedules?.length]);

  return (
    <div className={styles["work-summary-item"]}>
      {aiTitle ? (
        <div className={styles["title"]}>
          <span>使用</span>
          <div className={styles["text"]}>{`「${aiTitle}」`}</div>
        </div>
      ) : null}
      <div
        className={`${styles["content-wrap"]} ${sendType === MessageSendType.OTHER ? "other" : ""}`}
      >
        {showSummeryDetail ? <WorkCardDetail {...props} dataInfo={dataInfo} /> : null}
        <ReferenceHeader refs={message?.refs} />
        <div
          className={`top-box ${selectedSession.isSecret ? "top-box_isSecret" : ""}`}
          dangerouslySetInnerHTML={{
            __html: getTextMessageRemark(selectedSession, message, currentEmployee, "", -1).trim()
          }}
        />
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(WrokSummaryCard);
